import React from 'react';

export interface RevisionRequestEmailContentProps {
    reason: string;
    rfxLead: string;
    rfxName: string;
    supplierName: string;
}

const RevisionRequestEmailContent: React.FC<RevisionRequestEmailContentProps> = ({
    rfxName,
    rfxLead,
    reason,
    supplierName,
}) => {
    return (
        <table
            width="100%"
            style={{ backgroundColor: '#ffffff' }}
        >
            <tbody>
                <tr>
                    <td align="center">
                        <table
                            width="600"
                            style={{ maxWidth: '600px' }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '16px',
                                            lineHeight: '24px',
                                            color: '#1F2937',
                                            paddingBottom: '24px',
                                            paddingTop: '40px',
                                        }}
                                    >
                                        Hi {rfxLead || '[Rfx Lead]'},
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '16px',
                                            lineHeight: '24px',
                                            color: '#374151',
                                            paddingBottom: '20px',
                                        }}
                                    >
                                        {supplierName} has requested a revision to their quote submission for{' '}
                                        <strong>{rfxName || '[RFx Name]'}</strong>.
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '14px',
                                            lineHeight: '20px',
                                            color: '#6B7280',
                                            paddingBottom: '8px',
                                            fontWeight: 600,
                                        }}
                                    >
                                        Reason for revision request:
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '16px',
                                            lineHeight: '24px',
                                            color: '#374151',
                                            paddingBottom: '20px',
                                            backgroundColor: '#F9FAFB',
                                            padding: '12px 16px',
                                            borderLeft: '4px solid #D97706',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {reason || '[Revision reason will appear here]'}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Please review this request and approve or decline it in the Procuracon platform.
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            fontFamily: "Arial, sans-serif",
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            color: "#374151",
                                        }}
                                    >
                                        <br />
                                        Best Regards,
                                        <br />
                                        <br />
                                        <b>The Procuracon Team</b>
                                        <br />
                                        <i>Supporting transparent and efficient procurement</i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export { RevisionRequestEmailContent };
